import './MainLayout.scss';
import Navigation from './../Navigation/Navigation';
import Footer from './../Footer/Footer';
import Breadcrumbs from './../../common/Breadcrumbs/Breadcrumbs';

const MainLayout = ({ children, pageClass='' }) => {
  return (
    <div className="main-layout">
      <Navigation />
      <Breadcrumbs />

      <div className="main-content">
        <main className={`page ${pageClass}`}>{children}</main>
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;